import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { DeleteButton } from 'components/toolbars/DeleteButton';
import { RotateButton } from 'components/toolbars/RotateButton';


const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
		'& > *:not(:last-child)': {
			marginRight: theme.spacing(1),
		},
	},
}));

export const AppSecretRowActions = (props) => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<RotateButton
				label="resources.app-secrets.actions.rotate"
				title="resources.app-secrets.confirm_rotate.title"
				content="resources.app-secrets.confirm_rotate.content"
				notifyMessage="resources.app-secrets.rotated"
			/>
			<DeleteButton
				{...props}
				title="resources.app-secrets.confirm_delete.title"
				content="resources.app-secrets.confirm_delete.content"
				notifyMessage="resources.app-secrets.deleted"
			/>
		</div>
	);
};
